import React, { Component, PropTypes } from 'react';

class ModalMessage extends Component {

	action = () => {
		if (typeof this.props.fnAction == "function") {
			this.props.fnAction();
		} else {
			console.log("close modal");
		}
	}

    componentDidMount = () => {
        $("#modal-message").modal();
    }

    render() {
        return (
            <div className='modal fade' id='modal-message' tabIndex='-1' role='dialog' aria-labelledby='id-modal-title'>
				<div className='modal-dialog' role="document">
					<div className='modal-content'>
						<div className='modal-header'>
							<h4 className='modal-title' id='id-modal-title'>{this.props.titulo}</h4>
						</div>
						<div className='modal-body'>
							<p>{this.props.mensaje}</p>
						</div>
						<div className='modal-footer'>
							<button type='button' className='btn orange-btn' onClick={this.action} data-dismiss='modal'>Aceptar</button>
						</div>
					</div>
				</div>
			</div>
        );
    }
    
}

export default ModalMessage;


// WEBPACK FOOTER //
// ./src/registro/modalMessage.js